<script setup lang="ts">
// Badge persistant : etat reseau + count outbox pending (P8.G).
// Cliquable -> /outbox.

import { onMounted, onUnmounted } from "vue";
import { storeToRefs } from "pinia";
import { useOutboxStore } from "@/features/offline/stores/outbox-store";
import { useRouter } from "vue-router";

const store = useOutboxStore();
const { online, pendingCount, hasPending } = storeToRefs(store);
const router = useRouter();
let unbind: (() => void) | null = null;

onMounted(() => {
  void store.refresh();
  unbind = store.bindBrowserEvents();
});

onUnmounted(() => {
  unbind?.();
});

function open(): void {
  void router.push("/outbox");
}
</script>

<template>
  <button
    v-if="!online || hasPending"
    type="button"
    :class="['badge', { offline: !online, pending: hasPending && online }]"
    :aria-label="!online ? 'Hors ligne' : `${pendingCount} actions en attente`"
    @click="open"
  >
    <span class="dot" />
    <span v-if="!online">Hors ligne</span>
    <span v-else-if="hasPending">{{ pendingCount }} en attente</span>
  </button>
</template>

<style scoped>
.badge {
  position: fixed;
  bottom: 1rem;
  left: 1rem;
  background: var(--color-navy-light);
  color: var(--color-cream);
  border: 1px solid rgba(232, 160, 32, 0.3);
  border-radius: 999px;
  padding: 0.4rem 0.8rem 0.4rem 0.6rem;
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  cursor: pointer;
  font-size: 0.8rem;
  font-family: var(--font-mono);
  z-index: 40;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
}
.badge:hover {
  background: rgba(232, 160, 32, 0.1);
}
.dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--color-danger);
  flex-shrink: 0;
}
.badge.pending .dot {
  background: var(--color-or);
}
.badge.offline {
  border-color: rgba(184, 67, 74, 0.5);
}
</style>
